import { GetProvidersSearch } from 'src/api/types'
import { TSearchType } from 'src/shared/types'
import { CATEGORY } from '../../../refactor/helpers/constants'

export const getSearchType = (
  search: GetProvidersSearch,
  category: CATEGORY
): TSearchType => {
  if (category === CATEGORY.FACILITY) return 'facility'

  return search.name ? 'practitioner' : 'practice'
}
